import TutorService from "@/api/services/cobranza/tutor/TutorService"
import Vue from "vue"

const state = () => ({
    tutores: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "cedula",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    TUTORES: state => {
        return state.tutores
    },
    TUTORES_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_TUTORES: (state, payload) => {
        state.tutores = payload
    },

    SET_TUTORES_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_TUTOR: (state, payload) => {
        state.tutores.push(payload)
    },

    UPDATE_TUTOR: (state, payload) => {
        state.tutores = state.tutores.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_TUTOR: (state, payload) => {
        state.tutores = state.tutores.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_TUTORES: async ({ commit, state }, { filter, tutorEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await TutorService.get({ filter, tutorEstado, ...pagination })
            if (status === 200) {
                commit("SET_TUTORES", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los tutores, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_TUTORES: async ({ commit }) => {
        try {
            let { data, status } = await TutorService.getAll()
            if (status === 200) {
                commit("SET_TUTORES", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_TUTORES: async ({ commit }) => {
        try {
            let { data, status } = await TutorService.getAllRecords()
            if (status === 200) {
                commit("SET_TUTORES", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los tutores, inténtelo nuevamente"
            })
        }
    },

    LOAD_TUTOR_DETAILS: async ({ commit }, payload) => {
        try {
            let { data, status } = await TutorService.loadDetails(payload)
            if (status === 200) {
                commit("UPDATE_TUTOR", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar los detalles del tutor, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_TUTOR: async ({ commit }, payload) => {
        try {
            let { data, status } = await TutorService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_TUTOR", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial del tutor, inténtelo nuevamente"
            })
        }
    },

    ADD_TUTOR: async ({ commit }, payload) => {
        try {
            let { data, status } = await TutorService.post(payload)
            if (status === 201) {
                commit("ADD_TUTOR", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El tutor ha sido agregado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar el tutor, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_TUTOR: async ({ commit }, payload) => {
        try {
            let { data, status } = await TutorService.put(payload)
            if (status === 200) {
                commit("UPDATE_TUTOR", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El tutor ha sido modificado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el tutor, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_TUTOR: async ({ commit }, payload) => {
        try {
            let { status, data } = await TutorService.delete(payload)
            if (status === 204) {
                commit("DELETE_TUTOR", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El tutor ha sido eliminado satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_TUTOR", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "El tutor ha sido deshabilitado satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar el tutor, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
